import { render, staticRenderFns } from "./CloseSVG.vue?vue&type=template&id=c7ea793a&scoped=true"
import script from "./CloseSVG.vue?vue&type=script&lang=js"
export * from "./CloseSVG.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7ea793a",
  null
  
)

export default component.exports